import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ANSWER_TYPES } from '../interfaces/jobInterface';
import { timeFormatter } from '../utils/formatters.utils';
import { QuestionParameters } from './QuestionParamaters';

interface IProps {
  isVideoQuestion: boolean;
  isAssessment: boolean;
  timeLimit: number; // Can be thinkingTime for video qeusions or partDuration for assessments
  answerType: `${ANSWER_TYPES}`;
  duration: number;
  takes?: number;
}

export const Explanation:React.FC<IProps> = ({ isVideoQuestion, isAssessment, timeLimit, answerType, duration, takes }) => {
  const { t } = useTranslation();
  const time = timeFormatter(timeLimit);
  return (
    <div className="myinterview-widget-explanation myinterview-widget--rtl-support">
      <QuestionParameters
        answerType={answerType}
        duration={duration}
        takes={takes}
      />
      {isVideoQuestion && (
      <Text className="myinterview-widget-explanation__header" size="H2-Bold">
        {t('recorder.explanation.question.videoQuestionHeader')}
      </Text>
      )}
      <Text className="myinterview-widget-explanation__main" size="M-Semibold">
        {isVideoQuestion
        && (
        <>
            {t('recorder.explanation.question.isVideoQuestion')}
            &nbsp;

            {!!timeLimit && (
            <>
              {t('recorder.explanation.question.cannotPauseSkip')}
              &nbsp;
            </>
            )}

            {t('recorder.explanation.question.checkSpeakers')}
            &nbsp;
        </>
        )}
        {!!timeLimit && (
          t(`recorder.explanation.question.${isAssessment ? 'questionDuration' : 'questionThinkingTime'}`, { time })
        )}
      </Text>
    </div>
  );
};
